var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 10,
  viewBox: "0 0 15 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.722 0c-.555 0-1.3.328-1.67.738L.556 3.513c-.74.821-.74 2.151 0 2.974l2.498 2.775c.367.408 1.106.738 1.67.738h7.276a2 2 0 0 0 2.009-2V2c0-1.105-.896-2-2.009-2zm.286 3.5c.78 0 1.42.59 1.493 1.355L6.508 5c0 .78-.59 1.42-1.355 1.493l-.145.007c-.78 0-1.42-.59-1.493-1.355L3.508 5c0-.828.665-1.5 1.5-1.5"
})));
export default SvgTag;